import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import { useContext, useState } from "react";

function Navegacion() {
  const { navegacion, enavegacion, opcionMenu, eopcionMenu } =
    useContext(Contexto);

  function f_seleccionNavegacion(evento) {
    const programa = evento.currentTarget.id;
    const descripcion = evento.currentTarget.innerHTML;
    _f_.f_logicaNavegacion(
      programa,
      descripcion,
      opcionMenu,
      eopcionMenu,
      enavegacion,
    );
  }

  function f_establecerHome(evento) {
    _f_.f_logicaNavegacion(null, null, opcionMenu, eopcionMenu, enavegacion);
  }
  return (
    <>
      <div className={"cc-a-navegacion"}>
        <span className={"cc-a-n-elemento"} onClick={f_establecerHome}>
          Home
        </span>
        <span className={"cc-a-separador"}>{" \u00BB "}</span>
        {navegacion.map((n, i) => {
          return (
            <span key={i}>
              <span
                id={n.programa}
                onClick={f_seleccionNavegacion}
                className={"cc-a-n-elemento"}
              >
                {n.descripcion}
              </span>
              {i != navegacion.length - 1 && (
                <span className={"cc-a-separador"}>{" \u00BB "}</span>
              )}
            </span>
          );
        })}
      </div>
    </>
  );
}
export default Navegacion;
